<template>
  <card-deck :title="title">
    <div>
      <data-source
        v-for="(data, index) in contentData"
        :key="data.id"
        :index="index"
        v-bind:dataSource="data"
        :mappable="mappable"
        :type="type"/>
    </div>
    <component v-bind:is='location' />
  </card-deck>
</template>

<script>
import DataSource from '@/components/DataSource.vue'
import DataEngineAddAnalytics from '@/components/DataEngineAddAnalytics'
import DataEngineAddCRM from '@/components/DataEngineAddCRM'
import CardDeck from '@/components/CardDeck.vue'

export default {
  components: {
    CardDeck,
    DataEngineAddAnalytics,
    DataEngineAddCRM,
    DataSource
  },
  props: {
    location: {
      type: String
    },
    mappable: {
      type: String
    },
    contentData: {
      type: Array
    },
    type: {
      type: String
    },
    title: {
      type: String
    }
  },
  computed: {
  }
}
</script>
